module.exports = __webpack_public_path__ + "img/COFCO-TRUST-logo.ec325128.png";